import React from "react";

const Plain = () => <div className="flex flex-auto flex-col h-[100vh]"/>

export default Plain